/* This takes a class brefore it's class letter is changed to lower case and
   displays the before and after for a visual check that the change was correct. */
import React                                    from 'react'
import {
   Button,
   Card,
   CardActions,
   CardContent,
   Grid,
   Typography
}                                               from '@material-ui/core'
import PropTypes                                from 'prop-types'

const ClassLetterUpdateCheck = ( { display, handleCloseModal } ) => {

   const closeModal = () => {
      handleCloseModal()
   }

   return(
      <Grid>
         <Card variant='outlined' style={{ height: '700px', width: '650px' }} >
            <CardContent>
               <CardActions>
                  <Grid>
                     <Grid container >
                        <Grid item xs={5} >
                           <Typography align='center' variant='h6' >
                              Original
                           </Typography>
                        </Grid>
                        <Grid item xs={5} >
                           <Typography align='center' variant='h6' style={{marginLeft: '5rem'}} >
                              New
                           </Typography>
                        </Grid>
                     </Grid>
                     { display }
                  </Grid>
               </CardActions>
            </CardContent>
         </Card>
         <Button variant='contained' color='primary' onClick={closeModal} style={{marginTop: '1rem', marginBottom: '1rem'}} >
            Close
         </Button>
      </Grid>
   )
}

ClassLetterUpdateCheck.propTypes = {
   display:                                     PropTypes.array,
   handleCloseModal:                            PropTypes.func
}

export default ClassLetterUpdateCheck
